// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all tab blocks on the page
      ui.forms = doms(".form .form-wrapper");

      // Iterate over the blocks to bind to each
      for (var index = 0; index < ui.forms.length; index++) {
        var form = new FormBlock(ui.forms[index]);
      }

      // Bind the handler to the key down event on the document
      document.addEventListener("keydown", block.keydown);

    },

    /**
     * Method to handle the keyboard input.
     *
     * @method block.keydown
     */
    keydown: function(event) {

      var key = event.which;

      // Get the active element
      var active = document.activeElement;

      // Switch logic based on key pressed
      switch(key) {

        // Handle on press of the enter/return key
        case config.keys.RETURN:

          if (active.classList.contains("button")) {

          }

          break;

      }

    },

  };

  /**
   * Class for form blocks.
   *
   * @class FormBlock
   */
  var FormBlock = function(element) {

    this.form = {
      name: element.name,
      element: element,
      type: element.getAttribute("data-type"),
      meta: window.atob(dom("input[name='form-meta']", element).value),
      fieldsets: [],
      fields: {},
      valid: false,
    };

    this.bind();

    // Pre-populate the subject, if present and specified
    if (window.location.search.indexOf("?subject=") === 0) {
      var value = window.decodeURIComponent(
        window.location.search.replace("?subject=", "")
      );
      var option = dom(
        "option[name='Subject'][value='" + value + "']",
        this.form.element
      );
      if (value && option) {
        option.selected = true;
      }
    }

    if (this.form.type === "newsletter") {
      this.form.element.action = this.form.meta;
      this.form.element.target = "_blank";
      var user = document.createElement("input");
      user.name = "u";
      user.hidden = true;
      user.setAttribute("value", this.form.meta.split("?u=")[1].split("&")[0]);
      this.form.element.appendChild(user);
      var id = document.createElement("input");
      id.name = "id";
      id.hidden = true;
      id.setAttribute("value", this.form.meta.split("id=")[1].split("&")[0]);
      this.form.element.appendChild(id);
    }

  };

  /**
   * Method to handle the binding to the form.
   *
   * @method FormBlock.bind
   */
  FormBlock.prototype.bind = function() {

    var fieldsets = doms(".form-fieldset", this.form.element);

    for (var index = 0; index < fieldsets.length; index++) {

      var fieldset = fieldsets[index];
      var legend = dom(".form-fieldset-legend", fieldset);
      var fields = doms(".form-item", fieldset);

      var item = {
        fields: [],
      };

      if (legend) {
        item.legend = legend.innerText;
      }

      for (var i = 0; i < fields.length; i++) {

        var field = fields[i];
        var label = dom(".form-label-block", field);
        var isGroup = field.classList.contains("form-item-radio")
            || field.classList.contains("form-item-checkbox")
            || field.classList.contains("form-item-accept");

        // TODO: Handle radio/checkbox items
        var input = dom(".form-item-input", field);
        var type = input ? input.type : "text";
        var single = input;

        if (isGroup) {
          input = doms("input", field);
          label = dom(".form-input-fieldset", field);
          single = input[0];
          if (field.classList.contains("form-item-radio")) {
            type = "radio";
          } else if (field.classList.contains("form-item-checkbox")) {
            type = "checkbox";
          } else if (field.classList.contains("form-item-accept")) {
            type = "accept";
          }
        }

        if (!input) {
          continue;
        }

        var current = {
          element: field,
          label: label,
          input: input,
          type: type,
          required: single ? single.getAttribute("aria-required") === "true" : false,
          group: isGroup,
        };

        switch (type) {
          // case "text":
          //   current.regex = config.forms.regex.text;
          //   break;
          case "email":
            current.regex = config.forms.regex.email;
            break;
          case "tel":
            current.regex = config.forms.regex.phone;
            break;
        }

        // Get a reference to the error element
        current.error = document.getElementById(
          single.getAttribute("aria-describedby")
        );

        // Set default flags for if field is valid or has been used (dirty)
        current.valid = false;
        current.dirty = false;

        // Listen to the change or keyup event, bind `this` value to field data
        if (type.indexOf("select") === 0) {
          input.addEventListener("change", this.watch.bind(this, current));
        } else if (!isGroup) {
          input.addEventListener("keyup", this.watch.bind(this, current));
        }

        // Watch for blur/focus to change styling
        if (!isGroup) {
          input.addEventListener("blur", this.blur.bind(this, current));
          input.addEventListener("focus", this.focus.bind(this, current));
        } else {
          for (var ii = 0; ii < input.length; ii++) {
            input[ii].addEventListener("click", this.change.bind(this, current));
          }
        }

        // Add to the fieldset and fields lists
        this.form.fields[single.name] = current;
        item.fields.push(current);

      }

      // Add the fieldset data to the form reference
      this.form.fieldsets.push(item);

    }

    // Bind to form submit event
    this.form.element.addEventListener("submit", this.submit.bind(this));

  };

  /**
   * Method to handle the form submit.
   *
   * @method FormBlock.submit
   */
  FormBlock.prototype.submit = function(event) {

    var self = this;

    // Validate form input
    this.validate();

    // If form is invalid
    if (!this.form.valid) {

      // Prevent submission and event bubbling
      event.stopPropagation();
      event.preventDefault();

      // Mark all input as used / dirty now that form submit was attempted
      for (var name in this.form.fields) {
        if (this.form.fields[name].input) {
          this.form.fields[name].dirty = true;
        }
      }

      // This ensures the form does not submit
      return false;

    }

    if (this.form.type !== "newsletter") {
      // Prevent submission and event bubbling
      event.stopPropagation();
      event.preventDefault();
    }

    var legend = dom(".form-fieldset-legend-label", this.form.element);
    var address = this.form.meta;
    var title = document.title.split(" | ")[0];
    var name = legend ? legend.innerText : title;
    var endpoint = this.form.type === "newsletter"
      ? config.forms.endpoint.mailchimp
      : config.forms.endpoint.email;

    var data = {
      formname: name,
      fields: [],
    };

    if (this.form.type === "newsletter") {
      data.url = address;
    } else {
      data.address = address;
      data.fields.push({ label: "Page Title", value: title });
      data.fields.push({ label: "Page URL", value: window.location.href });
      data.fields.push({ label: "Form Name", value: name });
      var subject = dom("select[name='Subject']", this.form.element);
      data.subject = subject ? subject.value : name;
    }

    for (var name in this.form.fields) {
      var field = this.form.fields[name];
      if (!dom(".form-label", field.element)) {
        continue;
      }
      if (field.type === "file") {
        continue;
      }
      var value = field.input.value;
      var label = this.form.type === "newsletter"
        ? field.input.name
        : dom(".form-label", field.element).innerText;
      if (field.group) {
        if (field.type === "checkbox") {
          value = [];
          for (var i = 0; i < field.input.length; i++) {
            if (field.input[i].checked) {
              value.push(field.input[i].value);
            }
          }
          value = value.join(", ");
        } else if (field.type === "radio") {
          for (var i = 0; i < field.input.length; i++) {
            if (field.input[i].checked) {
              value = field.input[i].value;
            }
          }
        } else if (field.type === "accept") {
          value = field.input[0].checked ? "true" : "false";
        }
      }
      data.fields.push({ "label": label, "value": value });
    }

    if (this.form.type === "newsletter") {
      console.log("submit newsletter", address, data);
      return true;
    }

    if (dom("input[type='file']", this.form.element)) {
      this.upload(endpoint, address, data);
    } else {
      this.send(endpoint, address, data);
    }

  };

  /**
   * Method to handle the sending the form.
   *
   * @method FormBlock.send
   */
  FormBlock.prototype.send = function(endpoint, address, data) {

    var request = new XMLHttpRequest();
    var self = this;

    request.addEventListener("readystatechange", function() {
      if (this.readyState === this.DONE) {
        var success = this.status === 200;
        var response = this.responseText;
        // console.log(success, response);
        if (success) {
          var modal = dom(".form-modal", self.form.element);
          var close = dom(".button", modal);
          modal.classList.add("active");
          close.onclick = function(event) {
            event.preventDefault();
            modal.classList.remove("active");
          };
        } else {
          window.alert("An error occurred, please try again.");
        }
      }
    });

    request.open("POST", endpoint);

    request.setRequestHeader("content-type", "application/json");

    request.send(JSON.stringify(data));

    // console.log("submit", address, data);

  };

  /**
   * Method to handle the uploading files.
   *
   * @method FormBlock.uploadHandler
   */
  FormBlock.prototype.uploadHandler = function(file, endpoint, address, data) {

    var self = this;

    var signedUrlRequest = new XMLHttpRequest();
    signedUrlRequest.onerror = function() {};
    signedUrlRequest.onload = function() {
      if (signedUrlRequest.status !== 200) {
        return;
      }
      var signedUrl = JSON.parse(signedUrlRequest.responseText).url;
      var filePutRequest = new XMLHttpRequest();
      filePutRequest.onerror = function() {};
      filePutRequest.onload = function() {
        if (filePutRequest.status === 200) {
          self.uploadDone++;
          data.fields.push({ "label": "File Name", "value": file.name });
          data.fields.push({ "label": "File URL", "value": signedUrl.split("?")[0] });
          if (self.uploadDone >= self.uploadCount) {
            self.send(endpoint, address, data);
          }
        }
      };
      filePutRequest.open("PUT", signedUrl, true);
      filePutRequest.setRequestHeader("Content-Type", file.type);
      filePutRequest.send(file);
    };

    signedUrlRequest.open("POST", config.forms.endpoint.upload, true);
    signedUrlRequest.setRequestHeader("Content-Type", "application/json");
    signedUrlRequest.send(JSON.stringify({ filename: file.name }));

  };

  /**
   * Method to handle the uploading files.
   *
   * @method FormBlock.upload
   */
  FormBlock.prototype.upload = function(endpoint, address, data) {

    var input = dom("input[type=file]", this.form.element);

    this.uploadCount = input.files.length;
    this.uploadDone = 0;

    for (var index = 0; index < input.files.length; index++) {
      this.uploadHandler(input.files[index], endpoint, address, data);
    }

  };

  /**
   * Method to handle validating form input.
   *
   * @method FormBlock.validate
   */
  FormBlock.prototype.validate = function() {

    // Reset state before validating
    this.form.valid = true;

    // Loop over fields to validate
    for (var name in this.form.fields) {

      var field = this.form.fields[name];

      // Check against validation rules
      field.valid = this.check(field);

      // Toggle the valid state for the field
      this.toggle(field);

    }

  };

  /**
   * Method to handle watching form input.
   *
   * @method FormBlock.watch
   */
  FormBlock.prototype.watch = function(field) {

    // If the input has not been used, skip
    if (!field.dirty) {
      return;
    }

    // Check against validation rules
    field.valid = this.check(field);

    // Toggle the valid state for the field
    this.toggle(field);

  };

  /**
   * Method to handle checking a field against the validation rules.
   *
   * @method FormBlock.check
   */
  FormBlock.prototype.check = function(field) {

    var value = field.input.value;
    var valid = !field.required;

    // If the input has a regex to validate against
    if (field.regex) {
      if (value) {
        valid = value.match(field.regex);
      } else {
        valid = false;
      }
    } else if (field.group && field.required) {
      valid = false;
      for (var i = 0; i < field.input.length; i++) {
        if (field.input[i].checked) {
          valid = true;
        }
      }
    } else if (field.input.type === "file" && !field.input.files.length) {
      valid = false;
    } else if (field.dirty || field.value) {
      // TODO: Check against regex
      valid = !!value;
      // Prevent the first option from the select list from being used
      if (field.input.selectedIndex === 0) {
        valid = false;
      }
    }

    return valid;

  };

  /**
   * Method to handle on form input focus.
   *
   * @method FormBlock.focus
   */
  FormBlock.prototype.focus = function(field) {

    field.input.parentElement.classList.add("form-input-focus");

  };

  /**
   * Method to handle on form input blur.
   *
   * @method FormBlock.blur
   */
  FormBlock.prototype.blur = function(field) {

    // Update the styling
    field.input.parentElement.classList.remove("form-input-focus");

    // If not empty, mark as dirty/used
    if (field.input.value !== "") {
      field.dirty = true;
    }

    // If the input has been used, call the watch method to update
    if (field.dirty) {
      this.watch.call(this, field);
    }

  };

  /**
   * Method to handle on form input change.
   *
   * @method FormBlock.change
   */
  FormBlock.prototype.change = function(field) {

    // Update the styling
    field.label.classList.remove("form-input-invalid");
    field.label.classList.add("form-input-valid");

    // Skip if no error label is present
    if (!field.error) {
      return;
    }

    // Toggle the a11y attribute for display
    field.error.setAttribute("aria-hidden", "true");
    // Toggle the visual error message
    field.error.style.opacity = 0;

  };

  /**
   * Method to handle toggling form input state (styling, errors, a11y).
   *
   * @method FormBlock.toggle
   */
  FormBlock.prototype.toggle = function(field) {

    // Update the form valid state
    if (!field.valid && field.required) {
      this.form.valid = false;
    }

    // Toggle the class based on state
    if (field.valid) {
      field.label.classList.add("form-input-valid");
      field.label.classList.remove("form-input-invalid");
    } else if (field.required) {
      field.label.classList.add("form-input-invalid");
      field.label.classList.remove("form-input-valid");
    }

    // Toggle the a11y attribute for validation
    if (field.required) {
      if (field.group) {
        for (var i = 0; i < field.input.length; i++) {
          field.input[i].setAttribute("aria-invalid", field.valid ? "false" : "true");
        }
      } else {
        field.input.setAttribute("aria-invalid", field.valid ? "false" : "true");
      }
    }

    // Skip if no error label is present or if field is not required
    if (!field.error || !field.required) {
      return;
    }

    // Toggle the a11y attribute for display
    field.error.setAttribute("aria-hidden", field.valid ? "true" : "false");
    // Toggle the visual error message
    field.error.style.opacity = field.valid ? 0 : 1;

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
